module.exports = __webpack_public_path__ + "img/icon-search-focus.bc03ca6b.svg";